<template>
    <div>
        <header-portrate />
        <exports-print ref="exportbar" />
        <bread-crumbs :items="items"></bread-crumbs>
            <tabs-comp :tabs="tabs" />
        <div class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:15px !important;`">

            <div :style="`direction:`+lang.dir+`;margin:5px;margin-top:23px;margin-left:30px;margin-right:30px;`">

                <div :style="`direction:`+lang.dir+`;float:`+lang.lalgin+`;`+lang.lalgin+`:10px;margin-`+lang.lalgin+`:2px;`">
                    <button id="multiply-button" :class="`multiply-button-`+lang.lalgin" @click="addVendor()" v-b-toggle.add_vendor>
                        <div style="width:150px" :class="`multiply-button-content-`+lang.lalgin">{{lang.add_vendor}}</div>
                    </button>
                </div>
                <div style="clear:both;margin-bottom:5px;"></div>
                <v-simple-table class="mt-5 mb-10">
                    <thead>
                        <tr>
                            <th :class="`text-center ` + item.class" v-for="(item,index) in headers" :key="index">{{item.text}}</th>
                        </tr>
                        <tr>
                            <th :colspan="headers.length - 1" style="font-size:0.1rem !important;height:0.5rem !important;border-inline:none !important;"></th>
                            <th style="font-size:0.1rem !important;height:0.5rem !important;border-inline:none !important;"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in vendorrows" :key="index">
                            <td class="text-center">{{item.vendorid}}</td>
                            <td class="text-center">{{item.full_name}}</td>
                            <td class="text-center">{{item.mobile}}</td>
                            <td class="text-center">{{item.address}}</td>
                            <td class="text-center">{{item.vatid}}</td>
                            <td class="text-center" style="display:none;">{{item.invtotal}}</td>
                            <td class="text-center" style="display:none;">{{item.vattotal}}</td>
                            <td style="width:80px;background:darkred !important;border: 2px solid #fff !important;">
                                <v-btn style="box-shadow:none;font-size:0.2em;background:darkred;width:100%;color:#fff;height:25px !important;margin-left:5px;" @click="addVoucher(item,2)" v-b-toggle.add_vendor_addpayment>{{lang.add_vendor_voucher}}</v-btn>
                            </td>
                            <td style="width:80px;background:darkcyan !important;border: 2px solid #fff !important;">
                                <v-btn style="box-shadow:none;font-size:0.2em;background:darkcyan;width:100%;color:#fff;height:25px !important;margin-left:5px;" @click="addVoucher(item,1)" v-b-toggle.add_vendor_addpayment>{{lang.return_payment_from_vendor}}</v-btn>
                            </td>
                            <td style="width:80px;background:green !important;border: 2px solid #fff !important;">
                                <v-btn style="box-shadow:none;font-size:0.2em;background:green;width:100%;color:#fff;height:25px !important;margin-left:5px;" @click="getStatement(item)" v-b-toggle.vendor_ids>{{lang.client_statement}}</v-btn>
                            </td>
                            <td style="width:80px;background:red !important;border: 2px solid #fff !important;">
                                <v-btn style="box-shadow:none;font-size:0.2em;background:red;width:100%;color:#fff;height:25px !important;margin-left:5px;" @click="doAddinv(item)" v-b-toggle.add_addporch>{{lang.add_invoice}}</v-btn>
                            </td>

                            <td style="width:80px;background:darkred !important;border: 2px solid #fff !important;">
                                <v-btn style="box-shadow:none;font-size:0.2em;background:darkred;width:100%;color:#fff;height:25px !important;margin-left:5px;" @click="deleteIT(item)">{{lang.delete}}</v-btn>
                            </td>
                            <td style="width:80px;background:blue !important;border: 2px solid #fff !important;">
                                <v-btn style="box-shadow:none;font-size:0.2em;background:blue;width:100%;color:#fff;height:25px !important;margin-left:5px;" @click="doEdit(item)" v-b-toggle.add_vendor>{{lang.update}}</v-btn>
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </div>
            <div style="margin-bottom:25px;margin-top:-15px;">
                <v-container>
                    <div class="text-center pt-2">
                    <v-pagination
                        v-model="page"
                        value="15"
                        :length="pageCount"
                        color="#000"
                        @input="getNext(page)"
                    ></v-pagination>
                    </div>
                </v-container>
            </div>
        </div>
        <purchase ref="addBill" />
        <VendorStatement ref="getStatement" />
        <addVendorPayment ref="addVendorPayment" />
        <add-vendro ref="addVend" />
        <Footer />
        <div class="loadingPage" v-if="$store.state.showLoading">
            <v-progress-circular
                :width="3"
                color="green"
                indeterminate
            ></v-progress-circular>
            </div>
    </div>
</template>

<script>
import axios from 'axios'
import HeaderPortrate from '@/components/Header-Portrate.vue';
import BreadCrumbs from '@/components/breadCrumbs.vue';
import addVendorPayment from '@/components/addVendorPayment.vue';
import TabsComp from '@/components/tabsComp.vue';
import Purchase from '@/components/Purchase.vue';
import VendorStatement from './vendorStatement.vue';
import AddVendro from '@/components/addVendro.vue';
import Footer from '@/components/Footer.vue';
import {SnotifyPosition} from 'vue-snotify';
import ExportsPrint from '@/components/exports-print.vue';
export default {
    components: { HeaderPortrate, BreadCrumbs, TabsComp, Purchase,VendorStatement, AddVendro, Footer,addVendorPayment,ExportsPrint },
    data() {
        return {
            page: 1,
            pageCount:0,
            vendorrows: [],
            cpage:0,
            vendorid: '',
            vendor_name: '',
            vendor_vatid: '',
        }
    },
    computed:{
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki)  == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        headers: function(){
            let t = [
                {text:this.lang.vendorid,class:"backBlack"},
                {text:this.lang.vendor_name,class:"backBlack"},
                {text:this.lang.vendor_mobile,class:"backBlack"},
                {text:this.lang.vendor_address,class:"backBlack"},
                {text:this.lang.vendor_vatids,class:"backBlack"},
                // {text:this.lang.invoice_total,class:"backBlack"},
                {text:this.lang.add_vendor_voucher,class:"backBlack"},
                {text:this.lang.return_payment_from_vendor,class:"backBlack"},
                {text:this.lang.statment,class:"backBlack"}
            ]
            // if(this.$store.state.licenseType.activemenu != 'erpsam' && this.$store.state.licenseType.activemenu != 'erp'){
            //     t.push({text:this.lang.statment,class:"backBlack"})
            // }

            t.push({text:this.lang.add_invoice,class:"backBlack"})
            t.push({text:this.lang.delete,class:"backRed"})
            t.push({text:this.lang.action,class:"backBlue"})
            return t;

        },
        items: function() {
            return {
                    text: this.lang.vendors,
                    disabled: true,
                    to: '/inventory/vendors',
                }
        },
        tabs: function() {
            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            // console.log("currentMenu" , license);
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });

            let t = []
            Object.values(cMenu).forEach(value =>{

                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                    if(alicense[value.perms[0]] || value.perms[0] == 'any')
                        t.push(value)
                    }
                }

            })

            return t;
        },
    },
    created() {
        this.getVendors();
    },
    methods: {
        collectSearch(){
            return {
            module: 'vendors',
                elements: {
                    vendorid: this.vendorid,
                    vendor_name: this.vendor_name,
                    vendor_vatid: this.vendor_vatid,
                }
            }
        },
        addVoucher(item,recType){
            this.$refs.addVendorPayment.recType = recType
            this.$refs.addVendorPayment.vendorid = item.vendorid
            this.$refs.addVendorPayment.payment = {}
            this.$refs.addVendorPayment.generalPayment = true
            this.$refs.addVendorPayment.vInvoices = []
            this.$refs.addVendorPayment.doPayment()
        },
        addVendor(){
            this.$refs.addVend.vendorid = ''
            this.$refs.addVend.full_name = ''
            this.$refs.addVend.vatid = ''
            this.$refs.addVend.address = ''
            this.$refs.addVend.mobile = ''
            this.$refs.addVend.formtitle = this.lang.add_vendor
            this.$refs.addVend.SUBMIT_NAME = this.lang.add
        },
        doEdit(item){
            this.$refs.addVend.vendorid = item.vendorid
            this.$refs.addVend.full_name = item.full_name
            this.$refs.addVend.vatid = item.vatid
            this.$refs.addVend.address = item.address
            this.$refs.addVend.mobile = item.mobile
            this.$refs.addVend.is_customer = item.is_customer
            this.$refs.addVend.formtitle = this.lang.update_vendor
            this.$refs.addVend.SUBMIT_NAME = this.lang.update
        },
        getStatement(item){
            this.$refs.getStatement.accountn = item;
            this.$refs.getStatement.accountrows = [];

            this.$refs.getStatement.getReport();
        },
        doAddinv(item){
            this.$refs.addBill.vendorid = ''
            this.$refs.addBill.full_name = ''
            this.$refs.addBill.billifno = []
            this.$refs.addBill.vendorDisabled = true
            this.$refs.addBill.vatid = ''
            this.$refs.addBill.address = ''
            this.$refs.addBill.mobile = ''
            this.$refs.addBill.vendorid = '';
            this.$refs.addBill.showtype = true;
            this.$refs.addBill.vendorid = item.vendorid;
            this.$refs.addBill.vendorCheck();
        },
        getNext(page){
            this.cpage = parseInt(page) - 1;
            this.getVendors();
        },
        getVendors(){
            const post = new FormData();
            post.append('type','getVendors');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase))
            console.log(this.$store.state.LangCooki);
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki))
            post.append('data[cpage]',this.cpage)
            this.$store.state.showLoading = true;
            axios.post(
                this.$store.state.SAMCOTEC.r_path,post
            ).then((response) => {
                this.$store.state.showLoading = false;
                const res = response.data;
                // // console.log(res);
                this.pageCount = parseInt(parseInt(response.data.results.allres)/15) +1;
                this.vendorrows = res.results.data;
            })
        },
        deleteIT(item){
            let message = 'هل انت متاكد بانك تريد حذف المورد';
            this.$snotify.error(message, 'تنبيه', {
                timeout: 1000000,
                showProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                position: SnotifyPosition.centerCenter,
                buttons: [
                    {
                        text: this.lang.agree,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                            this.deleteITx(item);
                            // document.getElementById('addModalBTN').click()
                        }
                    },
                    {
                        text: this.lang.cancel,
                        action: (toast) => {
                            this.$snotify.remove(toast.id);
                            // document.getElementById('addModalBTN').click()
                        }
                    },
                ]
            });
        },
        deleteITx(item){
            const post = new FormData();
            post.append('type','delVendors');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase))
            post.append('data[lang]',this.$cookies.get(this.$store.state.LangCooki))
            post.append('data[id]',item.id)
            this.$store.state.showLoading = true;
            axios.post(
                this.$store.state.SAMCOTEC.r_path,post
            ).then((response) => {
                let message = this.lang[response.data.error.message];
                this.$snotify.error(message, 'تنبيه', {
                    timeout: 1000000,
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    position: SnotifyPosition.centerCenter,
                    buttons: [
                        {
                            text: this.lang.cancel,
                            action: (toast) => {
                                this.$snotify.remove(toast.id);
                                // document.getElementById('addModalBTN').click()
                            }
                        },
                    ]
                });
                this.$store.state.showLoading = false;
                this.getVendors();
            })
        }
    },
}
</script>